import { Component, OnInit } from '@angular/core';
import { SsrService } from 'src/app/services/ssr/ssr.service';

@Component({
  selector: 'app-ravneet',
  templateUrl: './ravneet.component.html',
  styleUrls: ['./ravneet.component.scss']
})
export class RavneetComponent implements OnInit {
  result:{name:string ,title:string, link:string} [] = [];
  constructor(private ssrService : SsrService) { }

  ngOnInit(): void {
    this.result = this.ssrService.getRavneet();
  }

}
